import { render, staticRenderFns } from "./MermaAceite.vue?vue&type=template&id=20c82288&scoped=true&"
import script from "./MermaAceite.vue?vue&type=script&lang=js&"
export * from "./MermaAceite.vue?vue&type=script&lang=js&"
import style0 from "./MermaAceite.vue?vue&type=style&index=0&id=20c82288&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c82288",
  null
  
)

export default component.exports